module.exports = __webpack_public_path__ + "img/solution.14771f7b.jpg";